<script setup>
  import { Sun, Moon, Adjust } from '@vicons/fa'
  import { NIcon, NPopover, NSwitch, NH4 } from 'naive-ui'
  import { computed, inject } from 'vue'

  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()
  const themeTitle = computed(() => `Theme - ${appStore.appTheme}`)
</script>
<template>
  <NPopover trigger="hover">
    <template #trigger>
      <NIcon :title="themeTitle">
        <Adjust />
      </NIcon>
    </template>
    <span class="flex-inline">
      <NH4>Application Theme</NH4>
      <NSwitch
        v-model:value="appStore.appTheme"
        checked-value="dark"
        unchecked-value="light"
        :title="themeTitle"
        @update:value="appStore.updateTheme"
        size="large"
      >
      </NSwitch>
      <span class="ml-5 mr-1 capitalize">{{ appStore.appTheme }}</span>
      <NIcon
        v-if="appStore.appTheme === 'light'"
        :component="Sun"
      />
      <NIcon
        v-else
        :component="Moon"
      />
    </span>
  </NPopover>
</template>
